import { ColorSchemeContextType } from "@/lib/main";
import { createContext } from "react";

const ColorSchemeContext = createContext<ColorSchemeContextType | null>(null);

export default ColorSchemeContext;
